import React, {Component} from 'react';
import styles from "./faceCollect.module.css";
import closeIcon from "../../../img/bt-close.png";
import {connect} from 'react-redux'
import bindAll from 'lodash.bindall';
import circleBig from '../../../img/circle-big.png';
import circleSmall from '../../../img/circle-small.png';
import face from '../../../img/face.png';
import icCameraFail from '../../../img/ic_camera_fail.png';
import Camera from './camera/cameraModal.jsx';
import PubSub from 'pubsub-js';
import {
    ali_accessKeyId,
    ali_accessKeySecret,
    ali_bucket,
    ali_region,
    ali_tmpimg_path,
} from '../../../util/constants.js';
import OSS from 'ali-oss';
import {ali_header_url, API_URL, FILE_URL} from "../../../util/constants";
import {faceEnterLibraryRequest} from "../../../service/user";
let client = new OSS({
    accessKeyId: ali_accessKeyId,
    accessKeySecret: ali_accessKeySecret,
    bucket: ali_bucket,
    region: ali_region
});

class FaceCollect extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'openCamera',
            'takeSnapshotSuccess',
            'selectImgMethod',
            'uploadImgToAlioss',
            'onCancel',
            'repeat',
            'confirm',
            'showToast'
        ]);
        this.state = {
            title: "",
            showCamera: false,
            currentImage: null,
            face_imgurl:false,
            isClick:true,
            cameraStatus:true
        }

        PubSub.subscribe('cameraOpenFail', (event, data) => {
            console.log(data);
           this.setState({
               cameraStatus:false
           })
        });

    }

    componentDidMount() {
        if(sessionStorage.getItem('face_imgurl')){
            this.setState({
                title:'人脸已采集，可更新照片',
                currentImage:sessionStorage.getItem('face_imgurl'),
                face_imgurl:true
            })
        }
    }

    onCancel() {
        PubSub.publish('cameraClose', '');
        this.props.onCancel();
    }

    repeat() {
        this.setState({
            showCamera: false,
            currentImage:null,
            title:'',
            face_imgurl:false
        })
    }

    confirm(){
        var that = this;
        const { isClick } = this.state;
        if(isClick) {
            this.setState({isClick: false});   //将isClick 变成false，将不会执行处理事件
            faceEnterLibraryRequest(this.state.currentImage, (data) => {
                console.log(data);

                setTimeout(function () {       // 设置延迟事件，1秒后将执行
                    that.setState({ isClick: true })   // 将isClick设置为true
                }, 1000);

                if(data.ret=='1'){
                    this.setState({
                        title:'人脸采集成功！',
                        face_imgurl:this.state.currentImage
                    })

                    sessionStorage.setItem('face_imgurl',this.state.currentImage);

                    PubSub.publish('faceCollectSuccess', '');

                }else {
                    //that.showToast(data.msg,1000);
                    that.setState({
                        title:'人脸采集失败！'
                    })
                }

            });
        }



    }

    openCamera() {
        if (this.state.showCamera) {
            if(this.state.cameraStatus){
                PubSub.publish('takeSnapshot', '');
            }
            // PubSub.publish('takeSnapshot', '');
        } else {
            this.setState({
                showCamera: true
            })
        }

    }

    selectImgMethod(e) {
        const reader = new FileReader();
        const thisFileInput = e.target;
        if (thisFileInput.files) {

            var index = thisFileInput.files[0].name.lastIndexOf(".");
            var suffix = thisFileInput.files[0].name.substring(index + 1);
            reader.readAsDataURL(thisFileInput.files[0]);
            var that = this;
            reader.onload = () => {
                that.setState({
                    showCamera: false
                })
                setTimeout(() => {
                    that.uploadImgToAlioss(reader.result)

                }, 100);


                thisFileInput.value = null;
            }

        }
    }

    uploadImgToAlioss(imageBase64) {
        var that = this;
        var pngFileName = `${(new Date()).getTime() + Math.floor(Math.random() * (900) + 100)}.png`;
        var pngFilePath = `${ali_tmpimg_path}${pngFileName}`;
        var imgBlob = this.dataURLtoFile(imageBase64);

        var imgUrl = ali_header_url + pngFilePath;

        client.put(pngFilePath, imgBlob)
            .then(function (r1) {
                console.log('ali uplload', r1);

                //that.faceEnterLibrary(imgUrl);
                that.setState({
                    currentImage: imgUrl,
                    showCamera: false
                })
            })

            .catch(function (err) {
                console.error('error: %j', err);
                that.showToast('采集失败', 1000);
            });
    }

    takeSnapshotSuccess(img) {
        this.setState({
            currentImage: img,
            showCamera: false

        })
    }

    dataURLtoFile(dataurl, filename = 'file') {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {type: mime})
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000;font-size:16px; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:99999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    render() {

        return (
            <div className={styles["modal-overlay"]}>
                <div className={styles["modal-content"]}>
                    <div className={styles.titlebar}>
                        <div className={styles["text-name"]}>
                            采集人脸
                        </div>

                        <img
                            className={styles.close}
                            src={closeIcon}
                            onClick={this.onCancel}
                        />
                    </div>

                    <div className={styles.body}>

                        <div className={this.state.title=='人脸采集失败！'?styles["title-red"]:styles.title}>{this.state.title}</div>


                        <div className={styles["container-face"]}>
                            <div className={styles["container-circle"]}>
                                <img className={styles.circle1} src={circleBig}/>
                                <img className={styles.circle2} src={circleSmall}/>
                                {!this.state.showCamera && this.state.currentImage == null ?
                                    <img className={styles.face} src={face}/> : null}
                                {!this.state.showCamera && this.state.currentImage !== null ?
                                    <img className={styles.photo} src={this.state.currentImage}/> : null}
                                {this.state.showCamera ?
                                    <div className={styles.camera}>
                                        {this.state.cameraStatus?
                                            null
                                            :<img className={styles["camera-fail"]} src={icCameraFail}/>}

                                        <Camera
                                            className={styles.camera}
                                            uploadImgToAlioss={this.uploadImgToAlioss}

                                        />
                                    </div>
                                    : null}
                            </div>

                        </div>

                        <div className={styles["div-bt"]}>


                            {this.state.currentImage == null ?
                                <div className={styles["button-input"]}>
                                    <input
                                        title=" "
                                        accept="image/jpeg, image/png, image/jpg, image/bmp"
                                        className={styles["button-input"]}
                                        type="file"
                                        onChange={this.selectImgMethod}
                                    />
                                    <div className={styles["text-upload"]}>
                                        上传图片
                                    </div>
                                </div>
                                : null}

                            {this.state.currentImage == null ?
                                <div className={styles.button} onClick={this.openCamera}>拍照</div>
                                : null}

                            {this.state.currentImage !== null&&!this.state.face_imgurl ?
                                <div className={styles.button} onClick={this.repeat}>重新采集</div>
                                : null}
                            {this.state.currentImage !== null&&!this.state.face_imgurl ?
                                <div className={styles.button} onClick={this.confirm}>确认</div>
                                : null}

                            {this.state.currentImage !== null&&this.state.face_imgurl ?
                                <div className={styles.button} onClick={this.repeat}>更新人脸照片</div>
                                : null}





                        </div>

                    </div>


                </div>


            </div>
        )
    }


}

FaceCollect.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FaceCollect);

